// Builder v2
export const BUILDER_DEFAULT_RIGHT_SIDEBAR_WIDTH = '32%';
export const BUILDER_TOP_BAR_HEIGHT = 45;
export const BUILDER_RIGHT_PANEL_ID = 'builder-right-panel';
export const BUILDER_ICON_FONT_SIZE = '1.25rem';
